const DEFAULT_OPTIONS = {
  offset: 0,
  padding: 20,
};

/**
 * Scrolls to some element while factoring in some arbitrary offset
 * and additional padding.
 *
 * @param { HTMLElement } - element
 * @param { Object } - options
 *
 * @returns { void }
 */
export default function scrollToElement(element, options = {}) {
  options = {
    ...DEFAULT_OPTIONS,
    ...options,
  };

  const { offset, padding } = options;
  const totalOffset = offset + padding;

  // Get position of element's top edge relative to the viewport's
  // to edge
  const { top } = element.getBoundingClientRect();

  // Just adding additional language
  const scrollDirection = top > totalOffset ? 'down' : 'up';
  const totalScrollByDirection = {
    up: (Math.abs(top) + totalOffset) * -1,
    down: top - totalOffset,
  };

  window.scrollBy({
    top: totalScrollByDirection[scrollDirection],
    behavior: 'auto',
  });
}
